import React, { Component } from "react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import { AgGridReact } from "ag-grid-react";
import FlexView from "react-flexview";
import PropTypes from "prop-types";
import { getLocaleText, getPinnedBottom, initializePinnedBottom, getSiNoFilterComponent, 
  getEstadoFilterComponent, getTipoUsuarioFilterComponent, LiteralTotalRegistros } from "./functions";
import "./styles.scss";
class DataGrid extends Component {
  constructor(props) {
    super(props);
  
    this.state = {
      //rowData: [],
      numRows: 0,
      headers: this.props.columnDefs.map((c) => {
        return c.headerName;
      }),
      columns: [],
      scroll: 0,
      pinnedBottom: initializePinnedBottom(props.columnDefs, props.pinnedBottomRowData),
      //frameworkComponents: { SiNoFilter: SiNoFilterComponent},
      rowClassRules:props.rowClassRules
    }

    this.onGridReady = this.onGridReady.bind(this);
    this.onFilterChanged = this.onFilterChanged.bind(this);
    this.onCellContextMenu = this.onCellContextMenu.bind(this);
    this.onRowDataChanged = this.onRowDataChanged.bind(this);
    this.onRowValueChanged = this.onRowValueChanged.bind(this);
    this.onCellValueChanged = this.onCellValueChanged.bind(this);
    this.onSelectionChanged = this.onSelectionChanged.bind(this);
    this.onRowClicked = this.onRowClicked.bind(this);
    this.onRowSelected = this.onRowSelected.bind(this);
    this.onContextMenuItemClicked = this.onContextMenuItemClicked.bind(this);
    this.navigateToNextCell = this.navigateToNextCell.bind(this);
    this.onModelUpdatedEvent = this.onModelUpdatedEvent.bind(this);
    this.onFilterChanged = this.onFilterChanged.bind(this);
    //this.onBodyScroll = this.onBodyScroll.bind(this);
    this.isExternalFilterPresent = this.isExternalFilterPresent.bind(this);
    this.doesExternalFilterPass = this.doesExternalFilterPass.bind(this);
  }

  render() {
    return (
      <>
        {this.renderStructureGrid(this.props)}
        {this.renderTotalRows()}
      </>
    );
  }

  componentDidUpdate(){
    this.autoSizeAll();
  }

  autoSizeAll() {
    var allColumnIds = [];
    if(this.columnApi)
    {
    this.columnApi.getAllColumns().forEach(function (column) {
      allColumnIds.push(column.colId);
    });
    this.columnApi.autoSizeColumns(allColumnIds);
    }
  }


  navigateToNextCell(params) {
    var previousCell = params.previousCellDef;
    var suggestedNextCell = params.nextCellDef;

    var KEY_UP = 38;
    var KEY_DOWN = 40;
    var KEY_LEFT = 37;
    var KEY_RIGHT = 39;

    switch (params.key) {
      case KEY_DOWN:
        previousCell = params.previousCellDef;
        // set selected cell on current cell + 1
        this.api.deselectAll();
        this.api.forEachNode((node) => {
          if (previousCell.rowIndex + 1 === node.rowIndex) {
            node.setSelected(true);
          }
        });
        return suggestedNextCell;
      case KEY_UP:
        previousCell = params.previousCellDef;
        // set selected cell on current cell - 1
        this.api.deselectAll();
        this.api.forEachNode((node) => {
          if (previousCell.rowIndex - 1 === node.rowIndex) {
            node.setSelected(true);
          }
        });
        return suggestedNextCell;
      case KEY_LEFT:
      case KEY_RIGHT:
        return suggestedNextCell;
      default:
        throw "this will never happen, navigation is always on of the 4 keys above";
    }
  }

  // onBodyScroll(event) {
  //   if (event.direction === "horizontal" && this.state.scroll < event.left) {
  //     if (this.props.autoSize) this.autoSizeAll();

  //     this.setState({
  //       scroll: event.left,
  //     });
  //   }
  // }

  onModelUpdatedEvent() {
    if (this.props.preselectedall) {
      this.api.selectAll();
    }
    if(this.api)
    {
      this.setState({ numRows: this.api.getDisplayedRowCount(),
      pinnedBottom: getPinnedBottom(this.props.columnDefs,this.api.getModel().rowsToDisplay)});
      
      // this.api.refreshClientSideRowModel('filter');
      // this.api.refreshClientSideRowModel('sort');
      this.autoSizeAll();
      //this.api.refreshCells({force: true});
      this.props.updateApi && this.props.updateApi(this.api,this.columnApi)
    }
  }

  onGridReady(params) {
    this.api = params.api;
    this.columnApi = params.columnApi;
    this.autoSizeAll();
    this.setState({
      pinnedBottom: getPinnedBottom(
        this.props.columnDefs,
        this.api.getModel().rowsToDisplay,
        this.props.pinnedBottomRowData
      ),
      numRows: this.api.getModel().rootNode.childrenAfterFilter.length,
    });
    this.props.updateApi && this.props.updateApi(params.api,params.columnApi)
  }

  onCellValueChanged(event) {
    if (this.props.onCellValueChanged && event.newValue !== event.oldValue) {
      this.props.onCellValueChanged(this.api, event);
    }
  }

  onCellContextMenu(event) {
    if (this.props.contextMenu) {
      event.event.preventDefault();
      this.refs.grid.api.deselectAll();
      event.node.setSelected(true);

      this.props.showMenu(this.props.contextMenu, {
        open: true,
        event: event.event,
        onMenuClick: this.onContextMenuItemClicked,
      });
    }
  }

  onSelectionChanged(event) {
    if (this.props.onSelectionChanged && (this.api.getSelectedRows().length || this.props.norowsevent)) {
      this.props.onSelectionChanged(this.api, this.api.getSelectedRows());
    }
  }

  onRowDataChanged(event) {
    if (this.props.onRowDataChanged) {
      this.props.onRowDataChanged(this.api, event);
    }
  }

  onRowValueChanged(event) {
    if (this.props.onRowValueChanged) {
      this.props.onRowValueChanged(this.api, event);
    }
  }

  onRowClicked(event) {
    if (this.props.onRowClicked) {
      this.props.onRowClicked(this.api, event);
    }
  }

  onRowSelected(event) {
    if (this.props.onRowSelected) {
      this.props.onRowSelected(this.api);
    }
  }

  onContextMenuItemClicked(opcion) {
    if (this.onContextMenuItemClicked) {
      let eventArgs = {
        opcion: opcion,
        data: this.refs.grid.api.getSelectedRows(),
      };

      this.props.onContextMenuItemClicked(this.api, eventArgs);
    }
  }

  // onDragStopped(event, fn) {
  //   if (fn)
  //     this.setState({
  //       columns: fn(this.columnApi.getColumnState()),
  //     });
  // }

  renderTotalRows() {
    return (
      <FlexView row className="bottom-container">
        <div className="label-rows">
          {LiteralTotalRegistros(this.props.translate)}
          {this.state.numRows}
        </div>
      </FlexView>
    );
  }

  isExternalFilterPresent(){
    if (this.props.isExternalFilterPresent) {
      return this.props.isExternalFilterPresent();
    }
  };

  doesExternalFilterPass(node){
    if (this.props.doesExternalFilterPass) {
      this.api.deselectAll();
      return this.props.doesExternalFilterPass(node.data,this.props.externalFilter);
    }
  };

  onFilterChanged(){
    this.api.deselectAll();
    this.props.onFilterChanged();
    this.props.updateApi && this.props.updateApi(this.api,this.columnApi)
  }

  renderStructureGrid(props) {
    return (
      <FlexView row className="ag-theme-balham" style={this.props.style}>
        <FlexView ref={React.createRef()} column className={`customGrid ${this.props.className}`}>
          <AgGridReact
            ref="grid"
            //enableCellChangeFlash={true}
            //getRowNodeId={this.props.getRowNodeId}
            //immutableData={this.props.inmutableData}
            rowData={this.props.data ? this.props.data : this.state.rowData}
            columnDefs={this.props.columnDefs}
            enableColResize={this.props.enableColResize}
            enableSorting={this.props.enableSorting}
            editType={this.props.editType}
            // rowHeight={this.props.rowHeight}
            rowDeselection={this.props.rowDeselection}
            rowSelection={this.props.rowSelection}
            getRowStyle={this.props.rowStyle}
            cacheQuickFilter={true}
            floatingFilter={this.props.floatingFilter}
            floatingBottomRowData={this.props.floatingBottomRowData}
            suppressRowClickSelection={this.props.suppressRowClickSelection}
            onGridReady={this.onGridReady}
            onCellValueChanged={this.onCellValueChanged}
            onCellContextMenu={this.onCellContextMenu}
            onSelectionChanged={this.onSelectionChanged}
            onRowDataChanged={this.onRowDataChanged}
            onRowClicked={this.onRowClicked}
            onRowSelected={this.onRowSelected}
            onRangeSelectionChanged={this.onRowSelected}
            onRowValueChanged={this.onRowValueChanged}
            onModelUpdated={this.onModelUpdatedEvent}
            onComponentStateChanged={this.onModelUpdatedEvent}
            localeText={getLocaleText(this.props.translate)}
            navigateToNextCell={this.navigateToNextCell}
            onFilterChanged={this.onFilterChanged}
            //onBodyScroll={this.onBodyScroll}
            multiSortKey="ctrl"
            // pagination= {true}
            // paginationPageSize={1000}
            //onDragStopped={this.onDragStopped}
            enableRangeSelection
            pinnedBottomRowData={this.state.pinnedBottom}
            isExternalFilterPresent={this.isExternalFilterPresent}
            doesExternalFilterPass={this.doesExternalFilterPass}
            rowClassRules={this.state.rowClassRules}
            components={{
              SiNoFilter : getSiNoFilterComponent(),
              EstadoFilter: getEstadoFilterComponent(),
              TipoUsuarioFilter: getTipoUsuarioFilterComponent()
            }}
          />
        </FlexView>
      </FlexView>
    );
  }

  onFilterChanged(event) {
    this.setState({
      pinnedBottom: getPinnedBottom(this.props.columnDefs, this.api.getModel().rowsToDisplay),
      numRows: this.api.getModel().rootNode.childrenAfterFilter.length,
    });
    if (this.props.onFilterChanged) {
      this.props.onFilterChanged(this.api, event);
    }
  }
}

DataGrid.propTypes = {
  autofit: PropTypes.bool,
  autoSize: PropTypes.bool,
  columnDefs: PropTypes.array.isRequired,
  data: PropTypes.array,
  ref: PropTypes.any,
  contextMenu: PropTypes.string,

  editType: PropTypes.oneOf(["single", "fullRow"]),
  enableColResize: PropTypes.bool,
  enableFilter: PropTypes.bool,
  enableSorting: PropTypes.bool,
  floatingFilter: PropTypes.bool,
  floatingBottomRowData: PropTypes.array,
  rowHeight: PropTypes.number,
  rowSelection: PropTypes.oneOf(["single", "multiple"]),
  rowDeselection: PropTypes.bool, //If true then rows will be deselected if you hold down ctrl + click the row.
  suppressCellSelection: PropTypes.bool, //If true, cells won't be selectable. This means cells will not get keyboard focus when you click on them.
  suppressRowClickSelection: PropTypes.bool, //If true, row selection won't happen when rows are clicked. Use when you want checkbox selection exclusively.

  onCellValueChanged: PropTypes.func,
  onCellContextMenu: PropTypes.func,
  onSelectionChanged: PropTypes.func,
  onRowDataChanged: PropTypes.func,
  onRowValueChanged: PropTypes.func,
  onRowClicked: PropTypes.func,
  onRowSelected: PropTypes.func,
  onContextMenuItemClick: PropTypes.func,

  columnVisible: PropTypes.func,
  onClickColumn: PropTypes.func,

  preselectedall: PropTypes.bool,
  norowsevent: PropTypes.bool,

  style: PropTypes.object,

  columnsState: PropTypes.array,
  onHideColumn: PropTypes.func,
  menuContent: PropTypes.any,
  handleCreatePDF: PropTypes.func,
  pinnedBottomRowData: PropTypes.array,
  updateApi: PropTypes.func,
  isExternalFilterPresent: PropTypes.func,
  doesExternalFilterPass: PropTypes.func
};

DataGrid.defaultProps = {
  autofit: true,
  autoSize: true,
  data: [],
  ref: undefined,
  floatingBottomRowData: [],

  editType: "fullRow",
  enableColResize: true,
  enableFilter: true,
  enableSorting: true,
  rowHeight: 25,
  rowSelection: "multiple",
  rowDeselection: false,
  suppressCellSelection: false,
  suppressRowClickSelection: false,

  preselectedall: false,
  norowsevent: false,

  getRowStyle: "",
  floatingFilter: false,
  styles: { width: "100vw", padding: "0.5rem" },
  columnsState: [],
  onHideColumn: () => {},
};

export default DataGrid;
